import React from 'react';

import {useGetTenantDataQuery} from 'src/containers/User';
import {sendMetrics} from 'src/utils';
import {invariant} from 'src/utils/invariant';

const useAuthorizedMetrics = () => {
  const {data: tenant} = useGetTenantDataQuery();

  return React.useCallback(
    (data) => {
      invariant('cannot use unauthorized metrics', tenant);

      sendMetrics(data, tenant?.tenantId);
    },
    [tenant?.tenantId],
  );
};

export {useAuthorizedMetrics};
